/**
 * Cookie-consent API client — the signed-in manager's server consent record (BR-11, BR-12).
 * The client itself is built by the shared factory in @resida/analytics.
 */

import { createCookieConsentApi } from '@resida/analytics';
import { apiFetch } from './api.core';

/** The server functions useCookieConsentSync injects into the consent store. */
export const cookieConsentApi = createCookieConsentApi({
  path: '/landlord/api/cookie-consent',
  apiFetch,
});
